// extracted by mini-css-extract-plugin
export default {"root":"dtPUZNN05dIOJfNlljwv","header":"ssEA28un8ZJ7bu739iTb"};